import { NavLink } from "react-router-dom";
import OpenNewTab from "../../hooks/OpenNewTab";

const WhatsappWidget = () => {
     const {openInNewTab} = OpenNewTab();
  return (
     <div className="position-fixed bottom-0 end-0 m-4">
        <NavLink to=""  title="As-salamu alaykum! How can I help you today? (Service available from 7 AM - 5.30 PM)"  onClick={(e) => openInNewTab('https://wa.me/+8801988461250')}  
            target="_blank" className="d-inline-flex align-items-center justify-content-center bg-white shadow-lg border rounded-circle p-2 text-decoration-none" style={{ width: "100%", height: "100%" }}>
            <img src="/asset/img/icon/hotline.gif" alt="whatsapp icon" width="60" height="60"/>
        </NavLink>
    </div>
  )
}

export default WhatsappWidget